import { render, staticRenderFns } from "./welcomeBeforeSession.vue?vue&type=template&id=34dda0bd&scoped=true&"
import script from "./welcomeBeforeSession.vue?vue&type=script&lang=js&"
export * from "./welcomeBeforeSession.vue?vue&type=script&lang=js&"
import style0 from "./welcomeBeforeSession.vue?vue&type=style&index=0&id=34dda0bd&prod&scoped=true&lang=css&"
import style1 from "./welcomeBeforeSession.vue?vue&type=style&index=1&id=34dda0bd&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.10.2/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34dda0bd",
  null
  
)

export default component.exports